// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-705f42ba] .aa-Form{border:none}[data-v-705f42ba] .aa-InputWrapperSuffix{display:none!important}[data-v-705f42ba] .aa-Form{box-shadow:none;display:flex;flex-direction:row-reverse}[data-v-705f42ba] .aa-SubmitIcon{color:var(--c-primary-800);cursor:pointer}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
